import {
  Component,
  Input,
  ChangeDetectionStrategy,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'membership-card',
  templateUrl: './membership-card.component.html',
  styleUrls: ['./membership-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MembershipCardComponent implements OnInit {
  @Input() membershipData: any;
  @Input() cardType: 'offerDiscountCard' | 'appliedDiscountCard' =
    'offerDiscountCard';

  get isCarousel(): boolean {
    return this.membershipData?.length > 1;
  }

  ngOnInit(): void {
  }
}
